import { useQuery } from '@tanstack/react-query';
import axiosInstance from '@/dataProvider/axios';
import { useAuthStoreV1 } from '@/stores/authStore_v1';
import { ORG_USAGE_ENDPOINT } from '@/services/org-admin';
import type { OrgUsageRollup } from '@/services/org-admin';

export function useOrgUsage() {
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id ?? null);

  return useQuery({
    queryKey: ['org-usage', orgId],
    queryFn: async () => {
      const { data } = await axiosInstance.get<OrgUsageRollup>(ORG_USAGE_ENDPOINT(orgId!));
      return data;
    },
    enabled: !!orgId,
    // Cached data still shows instantly on mount, but every visit to the Usage
    // tab re-fetches regardless of the global 1-minute staleTime — admins land
    // here specifically to check current spend/budget health.
    refetchOnMount: 'always',
  });
}
